import { Store, StoreDef } from '@ngneat/elf';
import { updateRequestStatus } from '@ngneat/elf-requests';
import { RecordKeys } from '@ngneat/elf-requests/src/lib/requests-status';
import { OperatorFunction } from 'rxjs';
import { tap } from 'rxjs/operators';

/**
 * Updates the request status in the specified store (elf) when an error occurs or when the source observable completes.
 *
 * @param {string} key - The key or identifier for the request status to be updated.
 * @param {S} store - The store where the request status will be updated.
 * @returns {OperatorFunction<T, T>} An operator function that can be used with the `pipe` method to update the request status.
 * @template T - The type of the elements emitted by the source observable.
 * @template S - The type of the store where the request status will be updated.
 */
export function updateRequestStatusOfKey<T, S extends StoreDef>(
  key: RecordKeys<S['state']>,
  store: Store<S>,
): OperatorFunction<T, T> {
  return source =>
    source.pipe(
      tap({
        error: (err: unknown) => store.update(updateRequestStatus(key, 'error', err)),
        complete: () => store.update(updateRequestStatus(key, 'success')),
      }),
    );
}
